import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/auth'
import { GameStore } from './modules/game/index'
import { CartStore } from './modules/cart/index'
import { DraftStore } from './modules/draft/index'
import { AssetStore } from './modules/asset/index'
import { PlayerStore } from './modules/player/index'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    AssetStore,
    GameStore,
    CartStore,
    DraftStore,
    PlayerStore,
  },
  plugins: [
    createPersistedState({ paths: ['CartStore', 'PlayerStore'] })
  ]
});
